// Contenu du blogue « Conseils », FR/EN.
// Tous les chiffres reprennent des faits déjà publiés sur le site
// (83 % chaleur, protection UV, 15 ans+ de durabilité,
// cure 30 jours, estimation gratuite 24-48 h).

export const BLOG_DATE = "2026-07-09";

export const blogCommon = {
  fr: {
    eyebrow: "Conseils",
    indexTitle: "Conseils pellicules | Reflectum Pellicule",
    indexDesc:
      "Guides honnêtes sur les pellicules pour fenêtres : miroir ou givrée, chaleur, UV, entretien. Conseils d'installateurs de Montréal et environs.",
    indexH1: "Conseils pour bien choisir votre pellicule.",
    indexIntro:
      "Des réponses franches aux questions qu'on nous pose chaque semaine, par une équipe qui installe des pellicules à Montréal, sur la Rive-Nord et la Rive-Sud.",
    readMore: "Lire l'article",
    backToBlog: "Retour aux conseils",
    ctaTitle: "Une question sur vos fenêtres ?",
    ctaText:
      "Chaque projet est unique : on évalue vos fenêtres, l'exposition et vos objectifs, puis on vous donne un prix clair. Estimation gratuite, réponse en 24 à 48 h.",
    ctaButton: "Obtenir mon estimation gratuite",
    exploreTitle: "Nos pellicules",
    published: "Publié le",
  },
  en: {
    eyebrow: "Advice",
    indexTitle: "Window Film Advice | Reflectum Pellicule",
    indexDesc:
      "Honest guides on window films: mirror or frosted, heat, UV, maintenance. Advice from installers in Montreal and surrounding areas.",
    indexH1: "Advice for choosing the right window film.",
    indexIntro:
      "Straight answers to the questions we hear every week, from a team that installs window films in Montreal, on the North Shore and the South Shore.",
    readMore: "Read the article",
    backToBlog: "Back to advice",
    ctaTitle: "A question about your windows?",
    ctaText:
      "Every project is unique: we assess your windows, their exposure and your goals, then give you a clear price. Free estimate, reply within 24 to 48 h.",
    ctaButton: "Get my free estimate",
    exploreTitle: "Our window films",
    published: "Published",
  },
};

export const blogPosts = {
  fr: [
    {
      slug: "miroir-ou-givree",
      path: "/conseils/miroir-ou-givree",
      metaTitle: "Miroir ou givrée : quelle pellicule choisir ? | Reflectum",
      metaDesc:
        "Pellicule miroir ou givrée ? Le miroir garde votre vue le jour, la givrée protège jour et nuit. Notre guide honnête pour choisir, pièce par pièce.",
      title: "Pellicule miroir ou givrée : laquelle choisir ?",
      excerpt:
        "Les deux bloquent les regards, mais pas de la même façon, et pas au même moment de la journée. Voici comment choisir, pièce par pièce, sans vous tromper.",
      sections: [
        {
          title: "Les deux bloquent les regards, pas de la même façon",
          text: "La pellicule miroir crée un effet réfléchissant vu de l'extérieur : durant la journée, impossible de voir à l'intérieur, pendant que vous gardez une vue claire vers l'extérieur. La pellicule givrée, elle, donne au verre un fini dépoli : la lumière naturelle traverse, mais les formes deviennent illisibles des deux côtés, vous ne voyez plus dehors, et personne ne voit dedans. C'est la première question à vous poser : voulez-vous garder la vue, ou seulement la lumière ?",
        },
        {
          title: "La règle du jour et de la nuit",
          text: "C'est le point que peu de vendeurs expliquent clairement : l'effet miroir dépend de la lumière. Il fonctionne tant qu'il fait plus clair à l'extérieur qu'à l'intérieur. Le soir, dans une pièce éclairée, l'effet s'inverse et l'on peut voir à l'intérieur, c'est vrai pour toutes les pellicules miroir, sans exception. Tamiser l'éclairage intérieur ou orienter un luminaire extérieur vers les fenêtres aide, mais si une pièce exige une intimité absolue en tout temps, la pellicule givrée est la seule qui protège jour et nuit, sans condition.",
        },
        {
          title: "Chaleur et UV : l'avantage du miroir",
          text: "Les deux familles offrent une protection contre les rayons UV, vos planchers, meubles et rideaux sont protégés dans les deux cas. Mais côté chaleur, le miroir domine : il rejette jusqu'à 83 % de la chaleur solaire avant qu'elle n'entre, et réduit fortement l'éblouissement sur les écrans. Si votre problème est double, regards ET surchauffe l'été, le miroir règle les deux d'un coup. Si seule l'intimité compte, la givrée suffit.",
        },
        {
          title: "Pièce par pièce : nos recommandations",
          text: "Salon, cuisine ou bureau face à la rue, où la vue compte le jour : miroir. Salle de bain, porte d'entrée vitrée, chambre au rez-de-chaussée, cloison de bureau, clinique ou vitrine, où l'intimité doit être permanente : givrée. Et rien n'oblige à choisir une seule pellicule pour toute la maison, dans la plupart de nos projets, on combine les deux : chaque fenêtre reçoit la pellicule adaptée à sa pièce et à son orientation.",
        },
        {
          title: "En résumé",
          text: "Gardez la vue + chaleur et UV en prime = pellicule miroir. Intimité totale jour et nuit + lumière douce = pellicule givrée. Dans les deux cas : pose propre en une journée pour la plupart des résidences, durée de vie de 15 ans et plus. Le plus simple reste de nous montrer vos fenêtres : l'estimation est gratuite et on vous dira franchement laquelle des deux convient, ou s'il vous faut les deux.",
        },
      ],
    },
    {
      slug: "anti-chaleur-avant-ete",
      path: "/conseils/anti-chaleur-avant-ete",
      metaTitle: "Pellicule anti-chaleur : l'installer avant l'été | Reflectum",
      metaDesc:
        "Les fenêtres plein sud transforment vos pièces en serre. La pellicule anti-chaleur rejette jusqu'à 83 % de la chaleur solaire. Pourquoi agir avant juillet.",
      title: "Pellicule anti-chaleur : pourquoi l'installer avant l'été",
      excerpt:
        "Chaque année, c'est le même appel au cœur de la première canicule : « ma pièce est invivable, est-ce que vous pouvez venir vite ? ». Voici pourquoi ça vaut le coup de s'y prendre avant.",
      sections: [
        {
          title: "Le problème : vos fenêtres agissent comme une serre",
          text: "Le vitrage laisse passer le rayonnement solaire, qui se transforme en chaleur une fois à l'intérieur, et cette chaleur reste prisonnière. Les fenêtres exposées plein sud ou plein ouest, les portes-patio, les verrières et les solariums sont les pires coupables : en après-midi, certaines pièces deviennent carrément inutilisables, et la climatisation tourne sans réussir à suivre.",
        },
        {
          title: "Ce que la pellicule change dès le premier jour",
          text: "La pellicule anti-chaleur se pose directement sur vos fenêtres existantes et rejette jusqu'à 83 % de la chaleur solaire avant qu'elle ne traverse le verre. La différence se sent immédiatement : les pièces exposées restent confortables en après-midi, l'éblouissement sur les écrans et les téléviseurs diminue fortement, et une protection contre les rayons UV, qui préserve au passage planchers, meubles et rideaux de la décoloration. Tout ça sans changer vos fenêtres et sans bloquer la lumière naturelle.",
        },
        {
          title: "Pourquoi s'y prendre avant la canicule",
          text: "Installer en juin plutôt qu'en pleine vague de chaleur, c'est profiter de tout l'été au lieu d'en sauver la moitié. Le processus est simple : vous demandez une estimation gratuite, on vous répond sous 24 à 48 heures, on évalue vos fenêtres et leur orientation, puis la pose prend une seule journée pour la plupart des résidences. Une fois la pellicule en place et la période de cure d'environ 30 jours passée, vous n'avez plus à y penser, elle dure 15 ans et plus.",
        },
        {
          title: "Combien ça coûte ?",
          text: "Ça dépend du nombre et de la taille de vos fenêtres, chaque projet est unique, et c'est pour ça que l'estimation est gratuite et sans engagement. Ce qu'on peut vous dire : c'est une fraction du prix d'un remplacement de fenêtres, qui dépasse souvent 15 000 $ pour une résidence.",
        },
      ],
    },
    {
      slug: "questions-avant-pose",
      path: "/conseils/questions-avant-pose",
      metaTitle: "4 questions avant d'installer une pellicule | Reflectum",
      metaDesc:
        "Durée de vie, fenêtres thermos, effet de nuit, entretien : les 4 questions à poser avant d'installer une pellicule pour fenêtres, et nos réponses.",
      title: "4 questions à poser avant de poser une pellicule sur vos fenêtres",
      excerpt:
        "Avant de signer quoi que ce soit, posez ces quatre questions à votre installateur. Voici les nôtres, avec nos réponses, les mêmes qu'on donne à nos clients chaque semaine.",
      sections: [
        {
          title: "1. Combien de temps la pellicule va-t-elle durer ?",
          text: "Nos pellicules durent 15 ans et plus : elles ne jaunissent pas, ne bullent pas et ne décollent pas. Demandez toujours quelle pellicule sera posée sur vos fenêtres.",
        },
        {
          title: "2. Est-ce compatible avec mes fenêtres thermos ?",
          text: "Question cruciale, souvent oubliée : sur certains types de vitrage, une pellicule solaire peut créer un risque de choc thermique et fissurer le verre. Un installateur sérieux évalue la compatibilité de chaque fenêtre AVANT la pose, c'est ce qu'on fait systématiquement, et vous informe de tout risque avant de commencer. Méfiez-vous de quiconque pose sans poser de questions.",
        },
        {
          title: "3. Est-ce que l'intimité tient la nuit ?",
          text: "Si on vous promet qu'une pellicule miroir protège votre intimité jour et nuit, c'est faux : son effet dépend de la lumière et s'inverse le soir dans une pièce éclairée. La miroir protège de jour ; pour une intimité permanente, il faut la pellicule givrée, qui masque les regards 24 h sur 24 tout en laissant passer la lumière. Un bon installateur vous le dira franchement et vous aidera à combiner les deux.",
        },
        {
          title: "4. Comment l'entretenir après la pose ?",
          text: "C'est beaucoup plus simple qu'on le croit : après une période de cure d'environ 30 jours, pendant laquelle la pellicule finit d'adhérer, vos fenêtres se nettoient normalement, chiffon doux et nettoyant sans abrasif. Aucun entretien spécial, aucun produit particulier, pour les 15 années et plus qui suivent.",
        },
      ],
    },
  ],
  en: [
    {
      slug: "miroir-ou-givree",
      path: "/conseils/miroir-ou-givree",
      metaTitle: "Mirror or Frosted Film: Which to Choose? | Reflectum",
      metaDesc:
        "Mirror or frosted window film? Mirror keeps your view by day, frosted protects day and night. Our honest guide to choosing, room by room.",
      title: "Mirror or frosted film: which one to choose?",
      excerpt:
        "Both block prying eyes, but not the same way, and not at the same time of day. Here's how to choose, room by room, without getting it wrong.",
      sections: [
        {
          title: "Both block gazes, not the same way",
          text: "Mirror film creates a reflective look from outside: during the day, no one can see in, while you keep a clear view out. Frosted film gives the glass a matte finish: natural light passes through, but shapes become unreadable from both sides, you can no longer see out, and nobody sees in. That's the first question to ask yourself: do you want to keep the view, or just the light?",
        },
        {
          title: "The day-and-night rule",
          text: "This is the point few sellers explain clearly: the mirror effect depends on light. It works as long as it's brighter outside than inside. In the evening, in a lit room, the effect reverses and people can see in, true of every mirror film, no exceptions. Dimming indoor lights or aiming an outdoor light at the windows helps, but if a room needs absolute privacy at all times, frosted film is the only one that protects day and night, unconditionally.",
        },
        {
          title: "Heat and UV: the mirror's edge",
          text: "Both families protect against UV rays, your floors, furniture and curtains are protected either way. But on heat, mirror wins: it rejects up to 83% of solar heat before it enters, and strongly reduces glare on screens. If your problem is twofold, gazes AND summer overheating, mirror solves both at once. If only privacy matters, frosted is enough.",
        },
        {
          title: "Room by room: our recommendations",
          text: "Living room, kitchen or office facing the street, where the view matters by day: mirror. Bathroom, glazed front door, ground-floor bedroom, office partition, clinic or storefront, where privacy must be permanent: frosted. And nothing forces you to pick one film for the whole house, in most of our projects, we combine both: every window gets the film suited to its room and orientation.",
        },
        {
          title: "In short",
          text: "Keep the view + heat and UV as a bonus = mirror film. Total day-and-night privacy + soft light = frosted film. Either way: clean installation in one day for most homes, a lifespan of 15 years and more. The simplest path is to show us your windows: the estimate is free, and we'll honestly tell you which one fits, or whether you need both.",
        },
      ],
    },
    {
      slug: "anti-chaleur-avant-ete",
      path: "/conseils/anti-chaleur-avant-ete",
      metaTitle: "Heat Control Film: Install It Before Summer | Reflectum",
      metaDesc:
        "South-facing windows turn your rooms into a greenhouse. Heat control film rejects up to 83% of solar heat. Why it pays to act before July.",
      title: "Heat control film: why install it before summer",
      excerpt:
        "Every year, the same call comes in during the first heat wave: “my room is unlivable, can you come fast?”. Here's why it's worth planning ahead.",
      sections: [
        {
          title: "The problem: your windows act like a greenhouse",
          text: "Glass lets solar radiation through, and it turns into heat once inside, heat that stays trapped. South- and west-facing windows, patio doors, glass roofs and solariums are the worst offenders: by afternoon, some rooms become downright unusable, and the air conditioner runs without ever catching up.",
        },
        {
          title: "What the film changes from day one",
          text: "Heat control film applies directly to your existing windows and rejects up to 83% of solar heat before it crosses the glass. The difference is felt immediately: sun-exposed rooms stay comfortable in the afternoon, glare on screens and TVs drops sharply, and built-in UV protection preserves floors, furniture and curtains from fading. All without replacing your windows and without blocking natural light.",
        },
        {
          title: "Why act before the heat wave",
          text: "Installing in June rather than mid-heat-wave means enjoying the whole summer instead of salvaging half of it. The process is simple: request a free estimate, we reply within 24 to 48 hours, we assess your windows and their orientation, then installation takes a single day for most homes. Once the film is in place and the roughly 30-day curing period has passed, you never think about it again, it lasts 15 years and more.",
        },
        {
          title: "How much does it cost?",
          text: "It depends on the number and size of your windows, every project is unique, which is why the estimate is free and commitment-free. What we can tell you: it's a fraction of the price of replacing windows, which often exceeds $15,000 for a home.",
        },
      ],
    },
    {
      slug: "questions-avant-pose",
      path: "/conseils/questions-avant-pose",
      metaTitle: "4 Questions Before Installing Window Film | Reflectum",
      metaDesc:
        "Lifespan, sealed windows, night effect, maintenance: the 4 questions to ask before installing window film, and our answers.",
      title: "4 questions to ask before putting film on your windows",
      excerpt:
        "Before signing anything, ask your installer these four questions. Here they are with our answers, the same ones we give our clients every week.",
      sections: [
        {
          title: "1. How long will the film last?",
          text: "Our films last 15 years and more: they don't yellow, bubble or peel. Always ask which film will be applied to your windows.",
        },
        {
          title: "2. Is it compatible with my sealed (thermal) windows?",
          text: "A crucial, often-forgotten question: on some glazing types, a solar film can create a thermal stress risk and crack the glass. A serious installer assesses every window's compatibility BEFORE installation, which we do systematically, and tells you about any risk before starting. Be wary of anyone who installs without asking questions.",
        },
        {
          title: "3. Does the privacy hold at night?",
          text: "If someone promises a mirror film protects your privacy day and night, that's false: its effect depends on light and reverses in the evening in a lit room. Mirror protects by day; for permanent privacy, you need frosted film, which blocks gazes 24 hours a day while letting light through. A good installer will tell you honestly and help you combine the two.",
        },
        {
          title: "4. How do I maintain it after installation?",
          text: "It's much simpler than people think: after a curing period of about 30 days, during which the film finishes bonding, your windows are cleaned as usual, soft cloth and non-abrasive cleaner. No special maintenance, no special product, for the 15 years and more that follow.",
        },
      ],
    },
  ],
};

export const getPost = (lang, slug) => blogPosts[lang].find((p) => p.slug === slug);
